/**
 * /usecases/launching-without-ops — a PAGE. AppLayoutRoute supplies the chrome.
 * Content lives in ../data/cases.ts; the template renders it.
 */
import { UseCaseTemplate } from '../components/UseCaseTemplate';

export default function LaunchingWithoutOpsPage() {
  return <UseCaseTemplate slug="launching-without-ops" />;
}
